// Centralized TanStack Query key factories. Keep all key construction here so
// invalidation across mutations stays consistent.

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  users: {
    all: ['users'] as const,
  },
  invites: {
    all: ['invites'] as const,
  },
  orgSystems: {
    all: ['orgSystems'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
  },
  ideas: {
    all: ['ideas'] as const,
    byId: (id: number) => ['ideas', id] as const,
  },
  audit: {
    list: (filter?: Record<string, unknown>) => ['audit', filter ?? {}] as const,
  },
  search: {
    query: (q: string) => ['search', q] as const,
  },
  chat: {
    session: ['chat', 'session'] as const,
  },
  components: {
    all: ['components'] as const,
    byId: (id: number) => ['components', id] as const,
  },
  projects: {
    all: ['projects'] as const,
    byId: (id: number) => ['projects', id] as const,
    progress: (id: number) => ['projects', id, 'progress'] as const,
    hostingHistory: (id: number) => ['projects', id, 'hostingHistory'] as const,
  },
  initiatives: {
    all: ['initiatives'] as const,
    byId: (id: number) => ['initiatives', id] as const,
    forProject: (projectId: number) =>
      ['initiatives', { projectId }] as const,
  },
  releases: {
    all: ['releases'] as const,
    byId: (id: number) => ['releases', id] as const,
    forProject: (projectId: number) =>
      ['releases', { projectId }] as const,
  },
  tickets: {
    all: ['tickets'] as const,
    list: (params: Record<string, unknown>) =>
      ['tickets', params] as const,
    byId: (id: number) => ['tickets', id] as const,
  },
  agents: {
    all: ['agents'] as const,
    byName: (name: string) => ['agents', name] as const,
  },
  files: {
    forProject: (projectId: number) => ['files', projectId] as const,
    text: (projectId: number, fileId: number) =>
      ['files', projectId, fileId, 'text'] as const,
  },
  repositories: {
    forProject: (projectId: number) => ['repositories', projectId] as const,
  },
};
